<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="공지사항 게시판 조회"
      desc="등록된 공지사항 게시물의 현황을 조회할 수 있습니다."
    ></admin-filter>

    <div class="btn-group-justify-end">
      <button @click="$router.push('notice/create')"
              class="button is-primary">글쓰기</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1200"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="modify_delete" slot-scope="props">
        <button class="button"
                @click.stop.prevent="clickItem(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button is-danger"
                @click.stop.prevent="clickItem(props.item,'delete')">삭제</button>
      </div>
    </admin-table>

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'NoticeList',
    mixins: [
      ListMixin
    ],

    data() {
      return {
        modalItem: 0
      }
    },

    created () {
      this.init();
    },

    methods: {
      init () {
        this.initializing('notice', 'board/notice');
      },
      getDataFromServer() {
        this.getData();
      },
      /*deleteItem(){
        this.$axios.delete(this.getUrl('board/notice/') + this.modalItem)
          .then(res => {
            if (res.status === 200) {
              this.$refs.deleteModal.close();
              this.getData();
              this.toast('견적폼이 삭제되었습니다.');
            }
          });
      },*/
      clickItem(item, kind) {
        if (kind === "update") {
          this.$router.push(this.getPath("notice/create?id=" +item.id));
        } else if (kind === "delete") {
          // this.modalItem = item.id;
          // this.$refs.deleteModal.open();
          let value = {
            id: item.id,
            url: 'board/notice/',
            title: '공지사항 게시판을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>

</style>
